import React, { useState, useEffect } from "react";
import CareCard from "../../components/cards/care-card";
import ServiceList from "../../components/sections/service-list";
import SubscriptionCard from "../../components/cards/subscription-card";
import img from "../../assets/images/poweredbymtn.png";
import { FloatButton } from "antd";
import whatsapp from "../../assets/images/WhatsApp.png";
import kobi from "../../assets/images/KUUL TRANS ROUND.png";
import ChatButton from "../../components/cards/message-card/chatButton";
import ChatInterface from "../../components/sections/chatai";
import KobikuulBanner from "../../components/layout/kobikuul-banner";

declare global {
  interface Window {
    ebanqo_widget: any;
  }
}

export default function Overview() {
  const [loading, setLoading] = useState(true); // State to manage SubscriptionCard loading
  const [isChatOpen, setIsChatOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer); // Cleanup timer
  }, []);

  return (
    <div className="min-w-0 max-w-full overflow-x-hidden">
      <div className="lg:hidden w-full bg-white border-b border-neutral-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6 max-[369px]:px-3 max-[369px]:py-4">
          <KobikuulBanner />
        </div>
      </div>

      <div className="p-4 max-[369px]:p-3">
      {/* Web View */}
      <div className="hidden lg:flex">
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-5">
          <CareCard />
          {/* Loader for SubscriptionCard */}
          {loading ? (
            <div className="bg-white p-4 rounded-lg shadow flex justify-center items-center">
              <div className="loader border-4 border-blue-500 border-t-transparent rounded-full w-8 h-8 animate-spin"></div>
            </div>
          ) : (
            <SubscriptionCard />
          )}
        </div>
      </div>

      {/* Mobile View */}
      <div className="lg:hidden flex flex-col gap-5">
        {/* Loader for SubscriptionCard */}
        {loading ? (
          <div className="bg-white p-4 rounded-lg shadow flex justify-center items-center">
            <div className="loader border-4 border-blue-500 border-t-transparent rounded-full w-8 h-8 animate-spin"></div>
          </div>
        ) : (
          <SubscriptionCard />
        )}
      </div>

      {/* ServiceList and CareCard remain visible */}
      <div className="grid grid-cols-1 gap-5 my-5">
        <ServiceList />
      </div>
      <div className="lg:hidden flex flex-col gap-5">
        <CareCard />
      </div>

      <div className="flex justify-center">
        <img src={img} alt="care" className="md:h-20 h-10 rounded-l-lg" />
      </div>

      <ChatButton />

      {isChatOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[10000] max-[369px]:px-2">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6 max-[369px]:p-4 relative max-[369px]:max-h-[90vh] max-[369px]:overflow-y-auto">
            <button
              onClick={() => setIsChatOpen(false)}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
            >
              ✖
            </button>
            <ChatInterface />
          </div>
        </div>
      )}

      <div className="fixed bottom-10 -right-2 z-[9999] transform scale-150 max-[369px]:scale-125 flex items-center ">
        <FloatButton.Group
          trigger="click"
          type="default"
          style={{ insetInlineEnd: 24 }}
          icon={
            <img
              src={whatsapp}
              alt="WhatsApp"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          }
        >
          <FloatButton
            icon={
              <img
                src={whatsapp}
                alt="WhatsApp"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            }
            onClick={() =>
              window.open(
                "https://wa.me/233555061412?text=Hello%20Medpharma%20Team%2C%20I%20need%20assistance",
                "_blank",
                "noopener,noreferrer"
              )
            }
          />
          <FloatButton
            icon={<img src={kobi} alt="kobikull" />}
            // description="Ask Kobikuul, your health bot"

            onClick={() => setIsChatOpen(true)}
          />
        </FloatButton.Group>
      </div>
      </div>
    </div>
  );
}
